import { IComponentOptions } from "angular";
import { ContractRelationshipsController } from "./controller";

export const vsComponentName = "contractRelationships";

export const contractRelationshipsComponentOptions: IComponentOptions = {
  controller: ContractRelationshipsController,
  controllerAs: "contractRelationshipController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contractRelationships: "<",
    contract: "<",
  },
};
